import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { emptyObject } from 'ui-components/default-props/empty';
import { AddressFields } from '../../../address/address-fields/index';
import { TimeZoneDropdown } from '../../../components/timezone-dropdown';
import { PHONE, COMPANY } from '../../../address/constants';
import style from '../style.module.less';
import { PHONE_NEEDED_FOR_SOME_CARRIERS } from '../../../address/sublabel-constants';

const ShipFromAddress = ({
  address,
  onChange: onAddressUpdated,
  errors = emptyObject,
  showValidation,
  shouldHideTimezone = false,
  trackInputChange = noop,
  trackInputClick = noop,
}) => {
  const additionalRequiredFields = [PHONE, COMPANY];
  const onChange = useCallback(
    (propertyName, value) => {
      onAddressUpdated({
        ...address,
        [propertyName]: value,
      });
    },
    [address, onAddressUpdated],
  );

  const onTimeZoneSelected = useCallback(
    (timeZone) => {
      const inputName = 'ianaTimeZone';
      onChange(inputName, timeZone.id);
      trackInputChange(inputName, timeZone.id);
    },
    [onChange, trackInputChange],
  );

  const subLabels = {
    [PHONE]: PHONE_NEEDED_FOR_SOME_CARRIERS,
  };

  return (
    <>
      <AddressFields
        additionalRequiredFields={additionalRequiredFields}
        address={address}
        errors={errors}
        onChange={onChange}
        showAllErrors={showValidation}
        subLabels={subLabels}
        trackInputChange={trackInputChange}
        trackInputClick={trackInputClick}
      />
      {!shouldHideTimezone && (
        <TimeZoneDropdown
          className={style['time-zone']}
          dropdownClassName={style['time-zone-dropdown']}
          hasError={errors?.ianaTimeZone}
          labelClassName={style['time-zone-label']}
          onTimeZoneSelected={onTimeZoneSelected}
          selectedTimeZone={address.ianaTimeZone}
          variant='form'
        />
      )}
    </>
  );
};

ShipFromAddress.propTypes = {
  address: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  shouldHideTimezone: PropTypes.bool,
  showValidation: PropTypes.bool.isRequired,
  trackInputChange: PropTypes.func,
  trackInputClick: PropTypes.func,
};

export default ShipFromAddress;
